import { TempLessonBlock } from '@/models/_deprecated/LessonBlock';
import {
  performCreateLessonBooks,
  performUpdateLessonBooks,
} from '@/utils/courseStudio/book';

async function performCreateBooks(newBlocks: TempLessonBlock[]) {
  const createdBlockLessonsWithBooks: TempLessonBlock[] = [];
  for (const block of newBlocks) {
    const createdLessonsBook = await performCreateLessonBooks(block.lessons);

    createdBlockLessonsWithBooks.push({
      ...block,
      lessons: createdLessonsBook,
    });
  }

  return createdBlockLessonsWithBooks;
}

async function performUpdateBooks(
  currentBlocks: TempLessonBlock[],
  newBlocks: TempLessonBlock[],
): Promise<TempLessonBlock[]> {
  const updatedBlocks: TempLessonBlock[] = [];

  for (const newBlock of newBlocks) {
    const currentBlock = currentBlocks.find(b => b.id === newBlock.id);
    if (!currentBlock) {
      updatedBlocks.push(newBlock);
      continue;
    }

    const updatedLessons = await performUpdateLessonBooks(
      currentBlock.lessons,
      newBlock.lessons,
    );

    updatedBlocks.push({
      ...newBlock,
      lessons: updatedLessons,
    });
  }

  return updatedBlocks;
}

export function useCourseStudioBook() {
  async function handleCreateBooks(newBlocks: TempLessonBlock[]) {
    const createdBlocks = await performCreateBooks(newBlocks);

    return createdBlocks;
  }

  async function handleUpdateBooks(
    currentBlocks: TempLessonBlock[],
    newBlocks: TempLessonBlock[],
  ) {
    const updatedBlocks = await performUpdateBooks(currentBlocks, newBlocks);

    return updatedBlocks;
  }

  return {
    handleCreateBooks,
    handleUpdateBooks,
  };
}
